<template>
  <div>
    <div class="cookies" v-if="!isAcceptCookies">
      <div class="cookies__inner">
        <div class="cookies__box">
          <button class="cookies__box--close" v-on:click="setAcceptCookies()"><img src="static/img/cookies__close.svg"></button>
          <span class="cookies__box--text">{{ $lang.cookies.bar.text }}</span>
          <a class="cookies__box--text cookies__box--link" v-on:click="toggleCookieModal()">{{ $lang.cookies.bar.link }}</a>
        </div>
      </div>
    </div>

    <div class="modal" v-bind:class="{'is-active': isActiveCookieModal}">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ $lang.cookies.modal.title }}</p>
          <button class="delete" v-on:click="toggleCookieModal()"></button>
        </header>
        <section class="modal-card-body">
          <div class="content" v-html="$lang.cookies.modal.text"></div>
        </section>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'cookies',
  data () {
    return {
      //variable for accept cookies
      isAcceptCookies: false,
      //variable for cookie modal state
      isActiveCookieModal: false
    }
  },

  methods: {
    setAcceptCookies () {
      //set cookie flag and disable cookiebox on site
      this.cookies = true;
      this.isAcceptCookies = true
    },

    toggleCookieModal () {
      // toggle cookies modal
      this.isActiveCookieModal = !this.isActiveCookieModal;
    }
  },

  created() {
    this.isAcceptCookies = this.cookies
  },

  computed: {
    cookies: {
      get() {
        return this.$cookies.isKey('AcceptCookies')
      },
      set(boolean) {
        return this.$cookies.set('AcceptCookies', boolean);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Cookies.vue?bffa6d3e